import { useCallback } from 'react'

import { countryCodeVar } from 'modulesCommon/store'

export const COUNTRY_CODE_PERSIST_KEY = 'countryCode'

export const useCountry = () => {
  const setCountry = useCallback<(countryCode: string) => void>(
    (countryCode: string) => {
      countryCodeVar(countryCode)
      localStorage.setItem(COUNTRY_CODE_PERSIST_KEY, countryCode)
    }, []
  )

  const getCountry = useCallback(() => {
    return localStorage.getItem(COUNTRY_CODE_PERSIST_KEY)
  }, [])

  return {
    setCountry,
    getCountry
  }
}
